import { Provider, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  AuditTrailOpener,
  NUCLEUS_ACCESS_REQUEST_AUDIT_TRAIL_OPENER,
  NUCLEUS_ACCESS_REQUEST_DATA,
  NUCLEUS_ACCESS_REQUEST_REPORT_FILENAME,
  NUCLEUS_ACCESS_REQUEST_SERVICE,
} from '@nucleus/access-request-ui';

import { AuditTraceComponent } from '../../common/audit-trace/audit-trace.component';
import { TasksenseAccessRequestServiceAdapter } from './tasksense-access-request.adapter';
import { TasksenseAccessRequestDataAdapter } from './tasksense-access-request-data.adapter';

export * from './tasksense-access-request.adapter';
export * from './tasksense-access-request-data.adapter';

/**
 * Provider list for @nucleus/access-request-ui's contract tokens.
 * Register in the module hosting <lib-access-request-management>
 * (AdministrationModule).
 *
 * The audit-trail-opener stays a tenant callback — it opens TaskSense's
 * AuditTraceComponent dialog, which isn't a @nucleus lib component yet.
 */
// NUC-294: the access-request lib gates on AccessRequestCaps codes via the
// shared CAPABILITY_CHECKER (wired app-wide to PermissionsService), and reads
// the current user + permission labels from APPLICATION_CONFIG; the old
// NUCLEUS_ACCESS_REQUEST_PERMISSIONS seam was removed in
// @nucleus/access-request-ui 0.0.9.
export const NUCLEUS_ACCESS_REQUEST_UI_PROVIDERS: Provider[] = [
  { provide: NUCLEUS_ACCESS_REQUEST_SERVICE, useExisting: TasksenseAccessRequestServiceAdapter },
  { provide: NUCLEUS_ACCESS_REQUEST_DATA, useExisting: TasksenseAccessRequestDataAdapter },
  { provide: NUCLEUS_ACCESS_REQUEST_REPORT_FILENAME, useValue: 'tasksense-access-request-report' },
  {
    provide: NUCLEUS_ACCESS_REQUEST_AUDIT_TRAIL_OPENER,
    useFactory: (): AuditTrailOpener => {
      const dialog = inject(MatDialog);
      return (entityName: string, entityId: number) => {
        dialog.open(AuditTraceComponent, {
          panelClass: 'bw-dialog-panel',
          width: '1100px',
          maxWidth: '95vw',
          height: '72vh',
          data: { entityName, entityId: String(entityId) },
        });
      };
    },
  },
];
